// Generated by Melange

import * as Buhta_cabinet__Link from "./Link.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as JsxRuntime from "react/jsx-runtime";

function Btn(Props) {
  let title = Props.title;
  let routeOpt = Props.route;
  let colorOpt = Props.color;
  let onClickOpt = Props.onClick;
  let linkOpt = Props.link;
  let className = Props.className;
  let disabledOpt = Props.disabled;
  let urlParamsOpt = Props.urlParams;
  let textOpt = Props.text;
  let type_Opt = Props.type_;
  const route = routeOpt !== undefined ? routeOpt : /* OrgChoose */ 0;
  const color = colorOpt !== undefined ? colorOpt : /* Blue */ 2;
  const onClick = onClickOpt !== undefined ? onClickOpt : (function (param) {
      
    });
  const link = linkOpt !== undefined ? linkOpt : false;
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const urlParams = urlParamsOpt !== undefined ? urlParamsOpt : /* [] */ 0;
  const text = textOpt !== undefined ? textOpt : /* He4 */ 0;
  const type_ = type_Opt !== undefined ? type_Opt : "button";
  let colorStyle;
  switch (color) {
    case /* White */ 0 :
      colorStyle = "bg-white border border-gray-main hover:bg-gray-pale";
      break;
    case /* Transparent */ 1 :
      colorStyle = "bg-transparent border border-gray-main hover:bg-gray-pale";
      break;
    case /* Blue */ 2 :
      colorStyle = "bg-links hover:bg-links-hover active:bg-links-active";
      break;
  }
  let textColorStr;
  switch (color) {
    case /* White */ 0 :
    case /* Transparent */ 1 :
      textColorStr = "text-black";
      break;
    case /* Blue */ 2 :
      textColorStr = "text-white";
      break;
  }
  let textEl;
  textEl = text === /* He4 */ 0 ? JsxRuntime.jsx(Buhta_components__Text.H4.make, {
      className: Cn.fromList({
        hd: "text-center",
        tl: {
          hd: textColorStr,
          tl: /* [] */ 0
        }
      }),
      children: title
    }) : JsxRuntime.jsx(Buhta_components__Text.H5.make, {
      className: Cn.fromList({
        hd: "text-center",
        tl: {
          hd: textColorStr,
          tl: /* [] */ 0
        }
      }),
      children: title
    });
  if (link) {
    return JsxRuntime.jsx(Buhta_cabinet__Link.make, {
      route: route,
      className: Cn.$plus(Cn.$plus("rounded-sm block", colorStyle), className),
      children: textEl,
      urlParams: urlParams
    });
  } else {
    return JsxRuntime.jsx("button", {
      children: textEl,
      className: Cn.$plus(Cn.$plus("rounded-sm block disabled:bg-default-gray disabled:cursor-not-allowed hover:border-default-gray active:border-gray-medium", colorStyle), className),
      disabled: disabled,
      type: type_,
      onClick: onClick
    });
  }
}

const make = Btn;

export {
  make,
}
/* Buhta_cabinet__Link Not a pure module */
